import Image from 'next/image';
import { Attribution, AttributionLink, Box } from '@99designs/emu';

export default function HowItWorksImage() {
    return (
        <Box display="flex" flexDirection="column">
            <Box
                position="relative"
                height={['270px', '500px', '500px', '500px']}
                width={['auto', 'auto', '700px', '700px']}
                marginTop={['2bu', '2bu', '2bu', 'none']}
                display="block"
            >
                <Image
                    src="/images/product-landing/hero/logo-design/contest-focus/How_it_works_thumbnail.png"
                    alt={__placeholder('by olimpio')}
                    objectFit="cover"
                    layout="fill"
                />
            </Box>
            <Box display="flex" flexDirection="column" alignItems="end">
                <Attribution>
                    <AttributionLink href="https://99designs.com/profiles/2116245">
                        {__placeholder('by olimpio')}
                    </AttributionLink>
                </Attribution>
            </Box>
        </Box>
    );
}
